<template>
	<div>
		<div class="header-sidebar mb-4" slot="header">
			<h4 class="pull-left">
				 {{ $t(parentName) }}
			</h4>
			<b-button class="pull-right close-btn" @click="close" type="button" variant="link"><i class="fa fa-close"></i></b-button>
			<div class="clearfix"></div>
			<hr>
		</div>
		<form>
			<b-form-group
				breakpoint="lg"
				label-size="sm"
				label-cols="4"
				:label="$t('goods.block.name')"
				label-for="refName"
				class="required"

			>
				<b-form-input :required="true" data-errormessage-value-missing="Bu maydon to'ldirilishi shart!"
							  size="sm"
							  v-model="item.name"
							  :placeholder="$t('goods.block.reference-name')"/>
			</b-form-group>

			<b-form-group
				label-size="sm"
				:label="$t('goods.block.code')"
				label-cols="4"
				label-for="refCode"
				class="required"
			>
				<b-form-input  :required="true"
							   size="sm"
							   data-errormessage-value-missing="Bu maydon to'ldirilishi shart!"
							   v-model="item.code"
							  :placeholder="$t('goods.block.reference-code')"/>
			</b-form-group>

			<b-form-group   :label="$t('goods.block.value')"
							label-size="sm"
							label-cols="4"
							label-for="refValue">
				<b-form-input   v-model="item.value"
							  size="sm"
							  :placeholder="$t('goods.block.reference-value')"/>
			</b-form-group>

			<b-form-group  :label="$t('goods.block.sort')"
						   label-cols="4"
						   label-size="sm"
						   label-for="refSort">
				<b-form-input  type="number"
							  size="sm"
							  v-model="item.sort"
							  label-class="font-weight-bold"
							  :placeholder="$t('goods.block.reference-sort')"/>
			</b-form-group>

			<b-form-group  :label="$t('mxikCode')"
						   label-cols="4"
						   label-size="sm"
						   label-for="refMxikCode">
				<b-form-input size="sm"
							  v-model="item.mxikCode"
							  label-class="font-weight-bold"
							  :placeholder="$t('mxikCode')"/>
			</b-form-group>
			<div class="model-actions">
				<b-row class="align-items-center">
					<b-col cols="6"  class="mb-3 mb-xl-0">
						<b-row>
							<b-col cols="6">
								<b-button block  size="sm"  type="button" @click="close" variant="outline-danger">{{ $t('cancel') }}</b-button>
							</b-col>
							<b-col cols="6">
								<b-button block type="button" size="sm" @click="create" variant="primary">{{ $t('save') }}</b-button>
							</b-col>
						</b-row>
					</b-col>
				</b-row>
			</div>
		</form>
	</div>

</template>

<script>
import ReferencesService from "../../../services/references.sevice";


const itemInitial = {
		id: null,
		code: '',
		name: '',
		value: '',
		sort: null,
		mxikCode: ''
	};


	export default {
        name: 'CreateReference',

		props: {
        	parentCode: {},
			parentName: {}
		},

		data() {
        	return {
				item: {
					id: null,
					code: '',
					name: '',
					value: '',
					sort: null,
					mxikCode: ''
				}
			}
		},

		methods: {
        	close() {
        		this.$emit('close', true)
			},
			create() {
        		ReferencesService.stroreChild(this.parentCode, this.item).then(response => {
        			this.$emit('reload', true);
        			this.$emit('close', true);
        			this.$emit('value', response.data);
        			this.item = itemInitial;
				}).catch((error) => {
					this.$vs.notify({
						title: this.$t('words.error'),
						text: 'error'
					})
				});
			}
		}
    }
</script>

<style scoped>

</style>
